import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { SharedModule } from 'app/shared';
import { AutopropBackend } from 'app/shared/backend';
import { SimpleNotificationsModule } from 'app/shared/toast';
import { ModalsService } from 'app/shared/ui/modals/modals.service';
import { throwError } from 'rxjs';
import { MiniSplashComponent } from './mini-splash/mini-splash.component';


const GENERIC_ERROR_MESSAGE = `Oops! Something unexpected occurred.
Our technical support team has been notified and are working to resolve this error.`;


@Component({
    selector: 'app-root',
    imports: [
        RouterModule,
        SharedModule,
        MiniSplashComponent,
        SimpleNotificationsModule,
    ],
    template: `
        <loading-bar></loading-bar>
        <mini-splash></mini-splash>
        <main overlaysTarget>
            <router-outlet></router-outlet>
            <router-outlet name="notifications"></router-outlet>
        </main>

        <toast-notifications class="ap-notification-list"></toast-notifications>
    `,
})
export class AppRootComponent {

    private backend = inject(AutopropBackend);

    private authService = inject(AuthService);

    private modalsService = inject(ModalsService);

    constructor() {
        this.configureBackend();
    }

    protected configureBackend() {
        this.backend.errorHandler = response => {
            const json = response.error;
            if (response.status === 400) {
                this.modalsService.alert(
                    (json.payload && json.payload.message) || GENERIC_ERROR_MESSAGE,
                    json.message || 'Request Error',
                    'danger'
                );
            }
            else if (response.status === 401) {
                this.authService.invalidateToken();
                this.modalsService.alert(
                    json.payload ||
                    `Authentication Error. Please try again or <a href="#" routerLink="/forgot-password">reset your Password</a>.`,
                    'Authentication Error',
                    'danger'
                );
            }
            else if (response.status === 500) {
                this.modalsService.alert(
                    (json.payload && json.payload.message) || GENERIC_ERROR_MESSAGE,
                    json.message || 'Internal Server Error',
                    'danger'
                );
            }
            else if (response.status === 0) {
                this.modalsService.alert(
                    'There was some error while sending a request, please check your internet connection.',
                    'Request Error',
                    'danger'
                );
            }
            if (json.status === false && typeof json.payload !== 'undefined') {
                return throwError(() => json);
            }
            return throwError(() => json);
        };
    }
}
